//export const API_URL = "https://www.grovtek.com/api/v1";
// export const API_URL = "https://menzill.com/api";
export const API_URL = "https://dev.menzill.com/api/";
// export const API_URL = "http://localhost:3000/api/";

export const MB = 1024 * 1024;

export const DEF_COORDS = { lat: "", lng: "" };
    